export default __webpack_public_path__ + "static/media/icon-flag-luxembourg.53b3a82c.svg";